import axios from "axios";
import moment from "moment";
import { getAuthHeaders } from "../helpers";

export const getAdCampaigns = (pageNo, perPage, filterParams) => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/ad_campaigns?page=${pageNo}&perpage=${perPage}`;
  if (filterParams?.clinicId) {
    url = `${url}&clinic_id=${filterParams?.clinicId}`;
  }

  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

export const getCampaignLeads = (pageNo, perPage, filterParams, searchText) => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/ad_campaign_leads?page=${pageNo}&perpage=${perPage}`;
  if (filterParams?.clinicId) {
    url = `${url}&clinic_id=${filterParams?.clinicId}`;
  }

  if (filterParams?.campaignId) {
    url = `${url}&ad_campaign_id=${filterParams?.campaignId}`;
  }

  if (searchText) {
    url = `${url}&search_text=${searchText}`;
  }

  if (filterParams.startDate) {
    const startDateFilter = filterParams.startDate
      ? moment(filterParams.startDate)
          .startOf("day")
          .utc()
          .format()
      : null;

    url = `${url}&start_time=${startDateFilter}`;
  }

  if (filterParams.endDate) {
    const endDateFilter = filterParams.endDate
      ? moment(filterParams.endDate)
          .endOf("day")
          .utc()
          .format()
      : null;
    url = `${url}&end_time=${endDateFilter}`;
  }

  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function updateCampaignStatus
 * @description This function  will update campagin active status
 */
export const updateCampaignStatus = params => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/ad_campaigns/${params?.id}`;
  return axios.put(url, params, {
    headers: getAuthHeaders()
  });
};

/**
 * @function downloadPatientReport
 * @param "clinicId", "fileId"
 * @description This function  will download the clinic patients csv file
 */
export const downloadLeadsReport = params => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/ad_campaign_leads/export_download?`;
  if (params.campaignId) {
    url = `${url}ad_campaign_id=${params.campaignId}&`;
  }
  if (params.startTime) {
    const startDateFilter = params.startTime
      ? moment(params.startTime)
          .startOf("day")
          .utc()
          .format()
      : null;
    url = `${url}start_time=${startDateFilter}&`;
  }
  if (params.endTime) {
    const endDateFilter = params.endTime
      ? moment(params.endTime)
          .endOf("day")
          .utc()
          .format()
      : null;
    url = `${url}end_time=${endDateFilter}&`;
  }
  if (params.searchText) {
    url = `${url}search_text=${params.searchText}&`;
  }
  if (params.clinicId) {
    url = `${url}clinic_id=${params.clinicId}`;
  }

  return axios.post(
    url,
    {},
    {
      headers: getAuthHeaders(),
      responseType: "arraybuffer"
    }
  );
};
